import type { Field } from "../../../types";

type Config = {
    type: string;
    name: string;
    label: string;
};

export const typeMap: Record<Exclude<Field, "password">, Config> = {
    firstName: {
        type: "text",
        name: "firstName",
        label: "firstNameLabel",
    },
    lastName: {
        type: "text",
        name: "lastName",
        label: "lastNameLabel",
    },
    phoneticFirstName: {
        type: "text",
        name: "phoneticFirstName",
        label: "phoneticFirstNameLabel",
    },
    phoneticLastName: {
        type: "text",
        name: "phoneticLastName",
        label: "phoneticLastNameLabel",
    },
    email: {
        type: "email",
        name: "email",
        label: "emailLabel",
    },
    dateOfBirth: {
        type: "text",
        name: "dateOfBirth",
        label: "dateOfBirthLabel",
    },
};
